import React from 'react';
import classNames from 'classnames';
import { keyCodes } from '../constants';
import '../../css/search.less';

/**
 * Provides either a Controlled or Uncontrolled search input
 *
 * Omitting both the onChange handler and value parameters will mean this component
 * is Uncontrolled. Supplying both makes the component Controlled.
 *
 * This option is available because in most cases an Uncontrolled search box is
 * adequate and provides backwards compatibility for existing callers.
 *
 * @param {Function} [onSearch] Passed the value of the search input
 * @param {Function} [onChange] Optional onChange handler
 * @param {String} value Optional value for the text input
 * @param {string} [className] Added to the root element
 * @description Renders a search input with search button
 */
const SearchInput = ({ onSearch, onChange, value, className }) => {

    const classes = classNames(className, 'search-input');

    const onButtonClick = onSearchCallback => ({ target }) => {
        const searchText = $(target).closest('.search-input').find('.search-input-text').val();
        onSearchCallback(searchText);
    };

    const onKeyUp = onSearchCallback => ({ keyCode, target }) => {
        if (keyCode === keyCodes.ENTER) {
            onSearchCallback(target.value);
        }
    };

    // Default uncontrolled input
    const props = {
        type: 'text',
        className: 'search-input-text',
        placeholder: 'Search',
        onKeyUp: onKeyUp(onSearch),
    };

    if (typeof onChange !== 'undefined' && typeof value !== 'undefined') {
        // Controlled input
        props.value = value;
        props.onChange = onChange;
    }

    return (
        <div className={classes}>
            <input {...props} />
            <button className="search-input-button" type="button" onClick={onButtonClick(onSearch)}>
                <span className="glyphicon glyphicon-search" />
            </button>
        </div>
    );
};

export default SearchInput;
